<template>
<div class="page_set page">
    <div class="list erji">
        <div class="item nickname">
            <van-field v-model="nickname" placeholder="请输入昵称" />
        </div>
    </div>
    <div class="tips">好名字让大家更能记住你。</div>
   <div class="big_btn btn" @click="tijiao">确认修改</div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "set-nickname",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            isClient: false, //是否在iOSAndroid客户端内显示
            token: null,
            nickname: '' //昵称
        };
    },
    created: function () {

    },
    mounted: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            this.setClientInfo()
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.setClientInfo()
                responseCallback('refresh success')
            })
            //注册方法，右上角设置按钮点击事件
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                var memberParams = {
                    'data': {
                        'forceLogin': 1,
                    }
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {

                })
                responseCallback('success')
            })
        } else {
            this.isClient = false
            // 获取列表
			this.token = this.$store.getters.token
			this.getData();
        }
    },
    methods: {
        setClientInfo() {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '修改昵称',
                    // 'hiddenBack': true,
                    // 'rightStyle': 'setup'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            console.log('sdjy://member/memberInfo')
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
					this.token = data.result.token
					this.getData()
				}
            })
		},
		// 获取用户信息
		getData(){
			if (this.token == null) {
                return
            }
            var params = {
                token: this.token
            }
            this.$api.my.info(params).then(res => {
                if (res.code == 200) {
					console.log('res')
                	console.log(res)
					this.nickname = res.result.thumb.nickname
                } 
            })
		},
		// 提交
		tijiao(){
			var params = {
				token: this.token,
			}
			if(this.nickname){
				params.nickname = this.nickname
			}
            this.$api.my.nickname(params).then(res => {
                console.log('res')
                console.log(res)
                if (res.code == 200) {
                    this.$toast('修改成功')
                    this.$router.back()
                } else {
                    this.$toast(res.message)
                }
            })
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
